import { render, staticRenderFns } from "./VField.vue?vue&type=template&id=0baddce5&"
import script from "./VField.vue?vue&type=script&lang=js&"
export * from "./VField.vue?vue&type=script&lang=js&"
import style0 from "./VField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports